import _ from 'lodash';
import { createSelector } from 'reselect';
import { State } from '../../../types';
import { WaiverWorkItemsState } from './waiverWorkItemsReducer';
import { WaiverWorkItem } from '../../../../types/waiverWorkItem';

const selectRoot = (state: State): WaiverWorkItemsState => 
  state.entities.waivers.workItems;

export const selectErrorMessage = (state: State): string =>
  selectRoot(state).error || '';

export const selectLoading = (state: State): boolean =>
  selectRoot(state).loading;

export const selectWorkItemsById = (state: State): { [key: number]: WaiverWorkItem } =>
  selectRoot(state).workItemsById;

export const selectWorkItems = createSelector(
  [selectWorkItemsById],
  workItemsById =>
    _(workItemsById)
      .values()
      .value(),
);